import Link from 'next/link';
import styles from './Navbar.module.css'
import { useRouter } from 'next/router';
import React, { useState,useEffect  } from 'react';
import * as CONSTANTS from '../utils/constants'

export default function Tab({  }) {
    const [isMobile, setIsMobile] = useState(false);
    //const {query} = useRouter();
    const [activeItem, setActiveItem] = useState('');
    const TAB_STYLE = ' whitespace-nowrap py-2 px-2 h-9 underline  cursor-pointer w-1/5';
    const TAB_MOBILE_STYLE = ' whitespace-nowrap py-2 px-2 h-9 underline  cursor-pointer';
    const SELECTED_STYLE = 'relative inline-block bg-blue-300 rounded-t-md font-semibold no-underline';
    const router= useRouter();
    const { slug } = router.query;

    useEffect(() => {
      // slug can be undefined (root), a string, or string[]
      // New path format: /image-generator/prompt-image/
      // slug array will be ["image-generator", "prompt-image"]
      let currentCategorySlug = undefined;
      if (typeof slug === 'string') {
        currentCategorySlug = slug;
      } else if (Array.isArray(slug) && slug.length >= 2) {
        currentCategorySlug = slug[1]; // e.g., "prompt-image" (second part of the path)
      } else if (Array.isArray(slug) && slug.length === 1) {
        currentCategorySlug = slug[0];
      }

      // console.log("Current slug for Tab activeItem:", currentCategorySlug);

      if (currentCategorySlug && CONSTANTS.CATEGORIES.includes(currentCategorySlug)) {
        setActiveItem(currentCategorySlug);
      } else {
        // Default to the first category in the list if slug is invalid, not present, or doesn't match
        // This also handles the root path ('/') effectively defaulting to the first tab.
        if (CONSTANTS.CATEGORIES && CONSTANTS.CATEGORIES.length > 0) {
          setActiveItem(CONSTANTS.CATEGORIES[0]);
        } else {
          setActiveItem(''); // Fallback if CATEGORIES is somehow empty
        }
      }
    }, [slug]); // Dependency array should include slug
    
  const handleClick = (event, href) => {
    event.preventDefault();
    //setActiveItem(href);
    //router.push(href);
    window.location.href = `/image-generator/${href}`;
    //onButtonClick();
    //router.replace(router.asPath);
  };
  
    return (
      <nav className={styles.tab} >
        
        <ul className={isMobile ? styles.navLinksMobile : styles.navLinks}>
          <div className="flex flex-wrap ">
            
            {CONSTANTS.CATEGORIES.map( (category, idx) => {
              // CONSTANTS.CATEGORIE_NAMES[idx] will give "Image", "Logo", etc.
              // We want to display "AI Image Generator", "AI Logo Generator", etc.
              const tabDisplayName = `AI ${CONSTANTS.CATEGORIE_NAMES[idx]} Generator`;

              return (
                <li className={ isMobile ? TAB_MOBILE_STYLE:(activeItem === category ? SELECTED_STYLE + TAB_STYLE :  TAB_STYLE)  } onClick={(e) => handleClick(e, category)} key={category}>
                  {tabDisplayName}
                </li>
              );
            })}
                    
          </div>     
          
        </ul>     
        
        <button   className={styles.mobileIcon }        onClick={() => setIsMobile(!isMobile)}      >
            {isMobile ? "" : <h3>Prompt Generators</h3>}   {/**<h3 >Close</h3> */}
          </button>  
        

      </nav>
    );
  }
